import { Box } from "@mui/material";
import React from "react";
import { ThreeDot } from "react-loading-indicators";
import { colors } from "./Colors";

const ThreeDotLoader = () => {
    return (
        <div>
            {" "}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    flexDirection: "column",
                    textAlign: "center",
                }}
            >
                <ThreeDot
                    color={colors.loaderColor}
                    size="small"
                    text=""
                    textColor=""
                />
            </Box>
        </div>
    );
};

export default ThreeDotLoader;
